// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-box[data-v-1545d8a5]{margin-top:16px}", ""]);
// Exports
module.exports = exports;
